import { render, staticRenderFns } from "./_base-checkbox-group.vue?vue&type=template&id=d621242c&"
import script from "./_base-checkbox-group.vue?vue&type=script&lang=js&"
export * from "./_base-checkbox-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports